export default "__VITE_ASSET__xmUQn6lX__"